/**
 * @packageDocumentation
 * @module HackerAPI.Event.Sponsor
 */
import { __extends } from "tslib";
import Prize from "./prize/prize";
import Base from "../../base/base";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../../utils/utils";
/**
 * A container for data related to sponsors
 * @class
 * @extends { HackerAPI.Base }
 */
var Sponsor = /** @class */ (function (_super) {
    __extends(Sponsor, _super);
    /**
     * Creates a new Sponsor instance
     * @constructor
     * @param sponsor
     */
    function Sponsor(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, name = _b.name, tier = _b.tier, website = _b.website, twitter = _b.twitter, company_id = _b.company_id, companyId = _b.companyId, prizes = _b.prizes, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt, available_perks = _b.available_perks, availablePerks = _b.availablePerks;
        var _this = _super.call(this, {
            id: Base.doNotSendHandler,
            name: Base.doNotSendHandler,
            website: Base.doNotSendHandler,
            twitter: Base.doNotSendHandler
        }) || this;
        /**
         * The sponsor ID
         * @type { number }
         */
        _this.id = id;
        /**
         * The company name
         * @type { number }
         */
        _this.name = name;
        /**
         * The company's sponsorship tier
         * @type { string }
         */
        _this.tier = tier;
        /**
         * The company's website
         * @type { string }
         */
        _this.website = website;
        /**
         * The company's twitter
         * @type { string }
         */
        _this.twitter = twitter;
        /**
         * The company's hackerapi ID
         * @type { number }
         */
        _this.companyId = company_id || companyId;
        /**
         * The prizes the company is sponsoring (unused for hackthenorth2017)
         * @type { HackerAPI.Event.Sponsor.Prize[] }
         */
        _this.prizes = (prizes || []).map(function (prize) { return new Prize(prize); });
        /**
         * The perks available to the sponsor
         * @type { any }
         */
        _this.availablePerks = available_perks || availablePerks;
        /**
         * The time the sponsor was created
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * The time the sponsor was last updated
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    Object.defineProperty(Sponsor, "Prize", {
        /**
         * The prize class
         * @returns
         */
        get: function () {
            return Prize;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the sponsors for an event
     * @param event
     * @param event.slug
     * @returns
     */
    Sponsor.fetchAll = function (_a) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/sponsors",
            method: "GET"
        }).then(function (data) {
            return data.map(function (datum) { return new Sponsor(datum); });
        });
    };
    /**
     * Gets info about a sponsor for an event
     * @param event
     * @param event.slug
     * @param sponsor
     * @param sponsor.id
     * @returns
     */
    Sponsor.fetch = function (_a, _b) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/sponsors/" + id,
            method: "GET"
        }).then(function (data) { return new Sponsor(data); });
    };
    /**
     * Adds a new sponsor for an event based on their company ID
     * @param event
     * @param event.slug
     * @param sponsor
     * @param sponsor.companyId
     * @param token
     * @returns
     */
    Sponsor.addSponsor = function (_a, sponsor, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/sponsors",
            method: "POST",
            body: sponsor.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Sponsor(data); });
    };
    /**
     * Updates a sponsor for an event
     * @todo Check on prizes to make sure right type
     * @param event
     * @param event.slug
     * @param sponsor
     * @param sponsor.companyId
     * @param token
     * @returns
     */
    Sponsor.update = function (_a, sponsor, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/sponsors/" + sponsor.id,
            method: "PUT",
            body: sponsor.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Sponsor(data); });
    };
    /**
     * Deletes a sponsor for an event
     * @param event
     * @param event.slug
     * @param sponsor
     * @param sponsor.companyId
     * @param token
     * @returns
     */
    Sponsor.delete = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/sponsors/" + id,
            method: "DELETE",
            token: token
        });
    };
    return Sponsor;
}(Base));
export default Sponsor;
//# sourceMappingURL=sponsor.js.map